export enum EUserDivision {
  WMG = 'WMG',
  WCM = 'WCM',
  MLR = 'MLR',
  CLA = 'CLA',
  WMG_WCM = 'WMG_WCM',
  WMG_WCM_MLR = 'WMG_WCM_MLR',
  WMG_MLR = 'WMG_MLR',
  WCM_MLR = 'WCM_MLR',
  WMG_WCM_CLA = 'WMG_WCM_CLA',
  ALL = 'WMG_WCM_MLR_CLA',
  WMG_CLA = 'WMG_CLA',
}

export interface IUser {
  companyCountry: string;
  companyName?: string;
  division?: EUserDivision | any;
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  phoneNumber?: string;
  showAlbumsArt?: boolean;
  username: string;
}
